var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFocus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 53 53",
    style: {
      enableBackground: "new 0 0 53 53"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.414,35H46c0.553,0,1-0.448,1-1s-0.447-1-1-1H34c-0.13,0-0.26,0.027-0.382,0.077c-0.244,0.101-0.439,0.296-0.541,0.541   C33.026,33.74,33,33.869,33,34v12c0,0.552,0.448,1,1,1s1-0.448,1-1v-9.586l16.293,16.293C51.488,52.902,51.744,53,52,53   s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L36.414,35z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.584,17.999H6.999c-0.552,0-1,0.448-1,1s0.448,1,1,1h12c0.13,0,0.26-0.027,0.382-0.077   c0.244-0.101,0.439-0.296,0.541-0.541c0.051-0.122,0.077-0.252,0.077-0.382v-12c0-0.552-0.448-1-1-1s-1,0.448-1,1v9.586   L1.707,0.293c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L16.584,17.999z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.382,33.077C19.26,33.027,19.13,33,19,33H7c-0.552,0-1,0.448-1,1s0.448,1,1,1h9.586L0.293,51.293   c-0.391,0.391-0.391,1.023,0,1.414C0.488,52.902,0.744,53,1,53s0.512-0.098,0.707-0.293L18,36.414V46c0,0.552,0.448,1,1,1   s1-0.448,1-1V34c0-0.13-0.027-0.26-0.077-0.382C19.821,33.373,19.627,33.179,19.382,33.077z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.618,19.923C33.74,19.973,33.87,20,34,20h12c0.553,0,1-0.448,1-1s-0.447-1-1-1h-9.586L52.707,1.707   c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L35,16.586V7c0-0.552-0.448-1-1-1s-1,0.448-1,1v12   c0,0.13,0.027,0.26,0.077,0.382C33.179,19.627,33.373,19.821,33.618,19.923z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,19c-4.136,0-7.5,3.364-7.5,7.5s3.364,7.5,7.5,7.5s7.5-3.364,7.5-7.5S30.636,19,26.5,19z M26.5,32   c-3.033,0-5.5-2.467-5.5-5.5s2.467-5.5,5.5-5.5s5.5,2.467,5.5,5.5S29.533,32,26.5,32z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocus);
export default __webpack_public_path__ + "static/media/focus.f69609953cfc809666bb29afd2792bff.svg";
export { ForwardRef as ReactComponent };